import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import QRTool from './QRTool';
import './BMSProjekte.css';

function Tagbar() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="bms-page">
      <button
        type="button"
        className="bms-back-button"
        onClick={() => {
          const scrollTo = location.state?.scrollTo || 'projects';
          navigate('/', { state: { scrollTo } });
        }}
      >
        {t.lebenslauf.back}
      </button>

      <h1>{t.tagbar.pageTitle}</h1>
      <div className="bms-meta">{t.tagbar.meta}</div>

      <div className="bms-description">
        <h2>{t.tagbar.descTitle}</h2>
        <p>{t.tagbar.descText}</p>
        <ul>
          <li>{t.tagbar.li1}</li>
          <li>{t.tagbar.li2}</li>
          <li>{t.tagbar.li3}</li>
        </ul>
      </div>

      <div className="bms-div">
        <h2>{t.tagbar.liveTitle}</h2>
        <div className="bms-grid bms-grid--narrow">
          <a
            href="https://qr.bauhaus.info/"
            target="_blank"
            rel="noopener noreferrer"
            className="bms-card bms-card--featured"
          >
            <span className="bms-card__badge">WordPress</span>
            <div className="bms-card__name">Tagbar – Bauhaus QR</div>
            <div className="bms-card__desc">{t.tagbar.cardDesc}</div>
            <div className="bms-card__link">{t.tagbar.openTool}</div>
          </a>
        </div>
      </div>
        <br />
      <div className="bms-div">
        <h2>Live Demo</h2>
        <p style={{ color: 'var(--text-secondary, #aaa)', fontSize: '0.9rem', marginBottom: '1rem' }}>
          Dynamic QR Codes: Ziel-URL jederzeit änderbar, ohne neuen Code zu generieren.
        </p>
        <QRTool embedded />
      </div>
    </div>
  );
}

export default Tagbar;
